<template>
  <div>
    <legend>Приход и расход</legend>

    <div>
      <create-ins @create-ins="createIns"></create-ins>
    </div>
    <div>
      <div class="mt-4">
        <div class="row">
          <div class="col" style="max-width: 200px;">
            <date-picker class="w-100" v-model="flowFrom" valueType="format"
                         placeholder="С"
                         :input-attr="{required: true}"
                         input-class="form-control"
                         :first-day-of-week="1" lang="ru">
            </date-picker>
          </div>
          <div class="col" style="max-width: 200px;">
            <date-picker class="w-100" v-model="flowTo" valueType="format"
                         placeholder="По"
                         :input-attr="{required: true}"
                         input-class="form-control"
                         :first-day-of-week="1" lang="ru">
            </date-picker>
          </div>
          <div class="col font-weight-bold" style="font-size: 1.3rem;">
            <div class="d-inline-block">Приход: <span class="text-success">{{inSum}}</span></div>
            <div class="ml-3 d-inline-block">Расход: <span class="text-danger">{{outSum}}</span></div>
          </div>
        </div>
      </div>

      <table class="table table-hover table-bordered mt-4">
        <thead>
        <tr>
          <th>Дата</th>
          <th>Тип</th>
          <th>Группа</th>
          <th>Вид</th>
          <th>Источник</th>
          <th>Счет</th>
          <th>Сумма</th>
          <th>Примечание</th>
          <th></th>
        </tr>
        </thead>
        <tbody>
        <tr v-for="item in items" :class="item.InsType == 'out' ? 'flow-out-bg' : 'flow-in-bg'">
          <td>{{item.CreateDate}}</td>
          <td>{{item.InsType}}</td>
          <td>{{item.ExpenseGroupName}}</td>
          <td>{{item.ExpenseTypeName}}</td>
          <td>{{item.PanelUserName}}</td>
          <td>{{item.PaymentTypeName}}</td>
          <td>{{item.Amount}}</td>
          <td>{{item.Description}}</td>
          <td class="text-center">
            <button type="button" class="btn btn-sm" @click.prevent="deleteFlow(item.Id)"
            v-if="item.RecordType === 'Expense'"
            >
              <font-awesome-icon :icon="['far', 'trash-alt']"/>
            </button>
          </td>
        </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>
<script>
import DatePicker from 'vue2-datepicker';
import moment from 'moment';
import { get, post } from '@/admin/services/api/http-utils';
import CreateIns from '@/admin/modules/Flow/_components/CreateIns.vue';

const queryString = require('query-string');

const defaultDateFrom = moment().subtract(10, 'd').format('YYYY-MM-DD');
const defaultDateTo = moment().format('YYYY-MM-DD');

export default {
  components: {
    CreateIns,
    DatePicker,
  },
  data() {
    return {
      items: [],
      total: [],
      inSum: 0,
      outSum: 0,
      flowFrom: defaultDateFrom,
      flowTo: defaultDateTo,
    };
  },
  async mounted() {
    await this.fetchData();
  },
  watch: {
    flowFrom() {
      this.fetchData();
    },
    flowTo() {
      this.fetchData();
    },
  },
  methods: {
    async fetchData() {
      this.items = [];
      this.total = [];
      this.in = 0;
      this.out = 0;
      const params = queryString.stringify({
        from: this.flowFrom,
        to: this.flowTo,
      });
      const { data } = await get(`${process.env.VUE_APP_API_HOST}admin/flow?${params}`);
      console.log(data, data.in);
      this.items = data.data;
      this.total = data.total;
      this.inSum = data.in;
      this.outSum = data.out;
    },
    async createIns() {
      await this.fetchData();
    },
    async deleteFlow(Id) {
      if (!confirm('Удалить?')) {
        return false;
      }

      await post(`${process.env.VUE_APP_API_HOST}admin/flow/remove`, {
        Id,
      });

      await this.fetchData();
    },
  },
};
</script>
<style lang="scss">
  .flow-out-bg {
    background-color: pink;
  }
  .flow-in-bg {
    background-color: lightgreen;
  }
</style>
